import "./style/normalize";
import "./style";

import { h, Component } from "preact";
import { route } from "preact-router";

// I18n
import { IntlProvider } from "preact-i18n";
import defaultDefinition from "./translations/nl.json";

import App from "./components/app";

export const NL_STRING = 'nl';
export const EN_STRING = 'en';

class LAndG extends Component {
  state = {
    lang: NL_STRING,
    definition: defaultDefinition,
    localeIsSet: false
  };

  switchLanguage = (lang = EN_STRING) => {
    import(`./translations/${lang}.json`)
      .then(definition => {
        this.setState(previousState => ({
          ...previousState,
          definition: definition.default,
          localeIsSet: true,
          lang
        }));
      })
      .catch(error => {
        console.error(`Couldn't switch to language ${lang} in LAndG:`, error);
        this.setState(previousState => ({
          ...previousState,
          definition: defaultDefinition
        }));
      });
  };

  componentDidMount() {
    const enRegex = new RegExp(`^/${EN_STRING}/?`);
    const nlRegex = new RegExp(`^/${NL_STRING}/?`);

    if (enRegex.test(window.location.pathname)) {
      return this.switchLanguage(EN_STRING);
    }
    if (nlRegex.test(window.location.pathname)) {
      return this.switchLanguage(NL_STRING);
    }

    this.setState(previousState => ({
      ...previousState,
      localeIsSet: true
    }));
  }

  render() {
    if (this.state.localeIsSet) {
      return (
        <IntlProvider definition={this.state.definition}>
          <App langSwitchClick={this.switchLanguage} locale={this.state.lang} />
        </IntlProvider>
      );
    }
  }
}

export default LAndG;
